import { useSentryMutation, useSentryQuery } from '../utils/sentryQueryWrapper';

import {
  fetchTeamMember,
  createTeamMember,
  fetchRoles,
  createRole,
  deleteTeamMember,
  deleteRole,
  updateTeamMember,
  updateRole,
  fetchPermissions,
} from '@/api';
import {
  TeamMemberRequest,
  TeamMemberResponse,
  RoleResponse,
  RoleRequest,
  Permission,
  ResponseListType,
  PermissionResponse,
} from '@/types';

// Fetch TeamMembers
export const useFetchTeamMembers = () => {
  return useSentryQuery<TeamMemberResponse, Error>(['teamMember-users'], fetchTeamMember, {
    keepPreviousData: true,
  });
};

// Create TeamMember
export const useCreateTeamMember = () => {
  return useSentryMutation<TeamMemberResponse, Error, TeamMemberRequest>(createTeamMember);
};

// Fetch Roles
export const useFetchRoles = () => {
  return useSentryQuery<RoleResponse, Error>(['teamMember-roles'], fetchRoles, {
    keepPreviousData: true,
  });
};

// Create Role
export const useCreateRole = () => {
  return useSentryMutation<RoleResponse, Error, RoleRequest>(createRole);
};

// delete TeamMember
export const useDeleteTeamMember = () => {
  return useSentryMutation<void, Error, string>(deleteTeamMember);
};

// delete Role
export const useDeleteRole = () => {
  return useSentryMutation<void, Error, string>(deleteRole);
};

// update TeamMember
export const useUpdateTeamMember = () => {
  return useSentryMutation<TeamMemberResponse, Error, TeamMemberRequest>(updateTeamMember);
};

//update role
export const useUpdateRole = () => {
  return useSentryMutation<RoleResponse, Error, RoleRequest>(updateRole);
};

// fetch permissions
export const useFetchPermissions = () => {
  return useSentryQuery<PermissionResponse, Error>(['teamMember-permissions'], fetchPermissions, {
    keepPreviousData: true,
  });
};
